import { INotification } from '@/model/interface/INotification'

export class NewPost implements PostUpdateInterface {
  id = undefined
  topicId: number
  parentId: number | null
  content = ''
  subscribe = false
  notifications: Array<INotification> = []

  public constructor(topicId: number, parentId: number | null = null) {
    this.topicId = topicId
    this.parentId = parentId
  }
}
